/**
 * API wrapper for the Bautagebuch-Büro view (Phase 5 Stufe I — Frontend
 * Slice 7, 2026-05-03). Read-only office sight across all diary entries
 * from all subs and all orders. Backend lives at /api/v1/bautagebuch
 * since the Stufe-F Owner-Switch (Service in auftraege/, perm
 * `bautagebuch:read`).
 */
import { api } from './api';

type BautagebuchFotoContentType = 'image/jpeg' | 'image/png' | 'image/heic' | 'image/webp';

export interface BautagebuchFotoMeta {
  id: string;
  contentType: BautagebuchFotoContentType;
  sizeBytes: number;
  originalFilename: string;
}

export interface BautagebuchBueroEintrag {
  id: string;
  auftragId: string;
  eintragDatum: string;
  text: string;
  createdAt: string;
  authorDisplayName: string;
  isOwn: boolean;
  canDelete: boolean;
  fotos: BautagebuchFotoMeta[];
  portalUserId: string;
  subunternehmerId: string | null;
  subunternehmerFirmenname: string | null;
  auftragTitel: string;
}

interface BautagebuchListFilter {
  subunternehmerId?: string;
  auftragId?: string;
  eintragDatumVon?: string;
  eintragDatumBis?: string;
  limit?: number;
}

function buildQuery(filter: BautagebuchListFilter): string {
  const params = new URLSearchParams();
  if (filter.subunternehmerId) params.set('subunternehmerId', filter.subunternehmerId);
  if (filter.auftragId) params.set('auftragId', filter.auftragId);
  if (filter.eintragDatumVon) params.set('eintragDatumVon', filter.eintragDatumVon);
  if (filter.eintragDatumBis) params.set('eintragDatumBis', filter.eintragDatumBis);
  if (filter.limit !== undefined) params.set('limit', String(filter.limit));
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export const bautagebuchApi = {
  async list(filter: BautagebuchListFilter = {}): Promise<{ items: BautagebuchBueroEintrag[] }> {
    return api<{ items: BautagebuchBueroEintrag[] }>(`/api/v1/bautagebuch${buildQuery(filter)}`);
  },

  fotoUrl(fotoId: string): string {
    return `/api/v1/bautagebuch/fotos/${fotoId}`;
  },
};
